export const SET_AUTO_PAY_ENABLED = 'SET_AUTO_PAY_ENABLED';
export const SET_CONFIRMATION_MODAL_OPEN = 'SET_CONFIRMATION_MODAL_OPEN';
export const SET_CONFIRMATION_MODAL_PLAN = 'SET_CONFIRMATION_MODAL_PLAN';
export const SET_KEEP_SHOPPING_NAVIGATION_DATA = 'SET_KEEP_SHOPPING_NAVIGATION_DATA';
export const ADD_PLAN = 'DISCOUNT_TOGGLE_BAR_ADD_PLAN';
export const ADD_PLAN_SUCCESS = 'DISCOUNT_TOGGLE_BAR_ADD_PLAN_SUCCESS';
export const ADD_PLAN_FAILURE = 'DISCOUNT_TOGGLE_BAR_ADD_PLAN_FAILURE';
export const ADD_PLAN_ID_TO_ADDED_LIST = 'ADD_PLAN_ID_TO_ADDED_LIST';
export const ADD_BACKUP_PLAN_ID_TO_ADDED_LIST = 'ADD_BACKUP_PLAN_ID_TO_ADDED_LIST';
export const ADD_BACKUP_PLAN = 'DISCOUNT_TOGGLE_BAR_ADD_BACKUP_PLAN';
export const ADD_BACKUP_PLAN_SUCCESS = 'DISCOUNT_TOGGLE_BAR_ADD_BACKUP_PLAN_SUCCESS';
export const ADD_BACKUP_PLAN_FAILURE = 'DISCOUNT_TOGGLE_BAR_ADD_BACKUP_PLAN_FAILURE';
export const UPDATE_PROCESS_STEP = 'PROGRESSIVE_PLANS_UPDATE_PROCESS_STEP';
export const ADD_POPULAR_PLAN = 'ADD_POPULAR_PLAN';
export const SET_ADDED_POPULAR_PLAN_ID = 'SET_ADDED_POPULAR_PLAN_ID';
export const SET_REMOVE_LINE_SUCCESS_UPDATE_CART_FAILED = 'SET_REMOVE_LINE_SUCCESS_UPDATE_CART_FAILED';